<template>
  <div
    style="
      background-color: #fff;
      border: 1px solid #e0e0e0;
      border-top: 0px;
      border-radius: 0 0 3px 3px;
      padding-top: 12px;
    "
  >
    <!-- SVG Gradient Definitions -->
    <svg width="0" height="0" style="position:absolute">
      <defs>
        <linearGradient id="gold-grad" x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FFECB3" />
          <stop offset="1" stop-color="#FFC107" />
        </linearGradient>
        <linearGradient id="silver-grad" x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FAFAFA" />
          <stop offset="1" stop-color="#BDBDBD" />
        </linearGradient>
        <linearGradient id="bronze-grad" x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
          <stop stop-color="#EFEBE9" />
          <stop offset="1" stop-color="#A1887F" />
        </linearGradient>
        <filter id="medal-shadow" x="-2" y="-2" width="36" height="36">
          <feDropShadow dx="0" dy="2" stdDeviation="2" flood-opacity="0.2"/>
        </filter>
      </defs>
    </svg>

    <div id="tabLeaderboards" class="margin-subpages" style="margin-top: 0">
      <div class="flex-row-between mt-24">
        <el-select
          v-model="selectTeam"
          filterable
          placeholder="Select"
          class="input-style"
          @change="changMainPageData"
          :class="[ blurMode ?  'blurelement': '' ]"
        >
          <el-option
            class="text-dropdown"
            v-for="item in teamAndcohort"
            :key="item.key"
            :label="item.name"
            :value="item.key"
            :class="[ blurMode ?  'blurelement': '' ]"
          ></el-option>
        </el-select>

        <div style="width: 200px">
          <el-menu
            id="menuSortMonth"
            class="el-menu-demo menuOptionPowerup"
            mode="horizontal"
          >
            <el-submenu index="1" style>
              <template slot="title">
                <span class="txtOptionShowing">{{ list_month_select }}</span>
              </template>
              <el-menu-item
                v-bind:key="item.id"
                v-for="item in list_month"
                index="1"
                @click="changeTime(item)"
                ><span class="menu-list-item">{{ item.name }}</span></el-menu-item
              >
            </el-submenu>
          </el-menu>
        </div>
      </div>

      <div class="flex-wrap mt-32" style="gap: 8px;">
        <div style=" height: 32px;" ref="all_recognition"><span  @click="setRecognition('All')"  :class="setClassRecognition('All')?'reconigtion-tags-selected center fs-13':'reconigtion-tags center fs-13'">{{'All Recognition'}}</span></div>
        <div
          v-for="(value) in recognition "
          :key="value.value + '_input'"
          class="relative"
        >
        <div   style=" height: 32px;"><span @click="setRecognition(value.label)"  :class="setClassRecognition(value.label)?'reconigtion-tags-selected center fs-13':'reconigtion-tags center fs-13'" >{{ value.label }}</span></div>
        </div>
      </div>
      <div class="center mt-20 mb-40 pt-20 pb-40" v-if="loadings">
            <loading-even></loading-even>
      </div>
      <div v-else>
        <!-- Recognition Metrics Section -->
        <div class="leaderboard-section mt-32">
          <div class="section-header">
            <span class="section-title fs-15 fw-700">Recognition Metrics</span>
            <span class="section-subtitle fs-12 opa-06 ml-12">Peer-to-peer recognition activity</span>
          </div>
          <div class="leaderboard-grid">
            <!-- Most Recognition Given -->
            <div class="leaderboard-card recognition-accent">
              <div class="card-header">
                <div class="card-title fw-700">Most Recognition Given</div>
                <div class="card-subtitle fs-12 opa-06">Top givers of peer recognition</div>
              </div>
              <div class="rank-list">
                <div v-for="(item,index) in recognitionGiven" :key="'given-'+index">
                  <div v-if="index<3" class="rank-item" :class="[ blurMode ? 'blurelement': '' ]">
                    <div class="rank-item-left">
                      <div class="rank-medal-wrapper" v-if="index < 3">
                        <svg width="32" height="32" viewBox="0 0 32 32" class="medal-icon">
                          <circle cx="16" cy="16" r="14" 
                            :fill="index === 0 ? 'url(#gold-grad)' : index === 1 ? 'url(#silver-grad)' : 'url(#bronze-grad)'" 
                            :stroke="index === 0 ? '#F9A825' : index === 1 ? '#9E9E9E' : '#8D6E63'" 
                            stroke-width="1"
                            filter="url(#medal-shadow)"
                          />
                          <text x="16" y="21" text-anchor="middle" font-size="15" font-weight="800" 
                            :fill="index === 0 ? '#916200' : index === 1 ? '#424242' : '#3E2723'" 
                            font-family="Lato, sans-serif">{{ item.order_Given }}</text>
                        </svg>
                      </div>
                      <span v-else class="rank-badge">{{ item.order_Given }}</span>
                      <div v-if="item.profilepic" class="profile-wrapper">
                        <img v-lazy="item.profilepic" :key="item.profilepic" class="image-profile-36 image-skeleton" />
                      </div>
                      <div v-else class="image image-profile-36">
                        <span class="text-in-image text-in-image-36 flex-mid">{{ item.shortname }}</span>
                      </div>
                      <div class="member-info">
                        <span class="member-name fs-13 fw-700 fc-000000">{{ item.firstname + ' ' + item.lastname }}</span>
                        <span class="member-team pt-2 fs-11 fw-400 opa-08 fc-000000">{{ item.teamname }}</span>
                      </div>
                    </div>
                    <div class="rank-value">
                      <span class="fs-14 fw-700 fc-000000">{{ item.given }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <span @click.prevent="showlistData(recognitionGiven,'recognition',3,'recognition_given','order_Given')" class="see-full-list">
                  See full list
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </div>
            </div>

            <!-- Most Recognition Received -->
            <div class="leaderboard-card recognition-accent">
              <div class="card-header">
                <div class="card-title fw-700">Most Recognition Received</div>
                <div class="card-subtitle fs-12 opa-06">Top receivers of peer recognition</div>
              </div>
              <div class="rank-list">
                <div v-for="(item,index) in recognitionReceived" :key="'received-'+index">
                  <div v-if="index<3" class="rank-item" :class="[ blurMode ? 'blurelement': '' ]">
                    <div class="rank-item-left">
                      <div class="rank-medal-wrapper" v-if="index < 3">
                        <svg width="32" height="32" viewBox="0 0 32 32" class="medal-icon">
                          <circle cx="16" cy="16" r="14" 
                            :fill="index === 0 ? 'url(#gold-grad)' : index === 1 ? 'url(#silver-grad)' : 'url(#bronze-grad)'" 
                            :stroke="index === 0 ? '#F9A825' : index === 1 ? '#9E9E9E' : '#8D6E63'" 
                            stroke-width="1"
                            filter="url(#medal-shadow)"
                          />
                          <text x="16" y="21" text-anchor="middle" font-size="15" font-weight="800" 
                            :fill="index === 0 ? '#916200' : index === 1 ? '#424242' : '#3E2723'" 
                            font-family="Lato, sans-serif">{{ item.order_Received }}</text>
                        </svg>
                      </div>
                      <span v-else class="rank-badge">{{ item.order_Received }}</span>
                      <div v-if="item.profilepic" class="profile-wrapper">
                        <img v-lazy="item.profilepic" :key="item.profilepic" class="image-profile-36 image-skeleton" />
                      </div>
                      <div v-else class="image image-profile-36">
                        <span class="text-in-image text-in-image-36 flex-mid">{{ item.shortname }}</span>
                      </div>
                      <div class="member-info">
                        <span class="member-name fs-13 fw-700 fc-000000">{{ item.firstname + ' ' + item.lastname }}</span>
                        <span class="member-team pt-2 fs-11 fw-400 opa-08 fc-000000">{{ item.teamname }}</span>
                      </div>
                    </div>
                    <div class="rank-value">
                      <span class="fs-14 fw-700 fc-000000">{{ item.received }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <span @click.prevent="showlistData(recognitionReceived,'recognition',4,'recognition_recieved','order_Received')" class="see-full-list">
                  See full list
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </div>
            </div>

            <!-- Highest Give-to-Receive Ratio -->
            <div class="leaderboard-card recognition-accent">
              <div class="card-header">
                <div class="card-title fw-700">Highest Give-to-Receive Ratio</div>
                <div class="card-subtitle fs-12 opa-06">Most peer recognition given per received</div>
              </div>
              <div class="rank-list">
                <div v-for="(item,index) in recognitionRatio" :key="'ratio-'+index">
                  <div v-if="index<3" class="rank-item" :class="[ blurMode ? 'blurelement': '' ]">
                    <div class="rank-item-left">
                      <div class="rank-medal-wrapper" v-if="index < 3">
                        <svg width="32" height="32" viewBox="0 0 32 32" class="medal-icon">
                          <circle cx="16" cy="16" r="14" 
                            :fill="index === 0 ? 'url(#gold-grad)' : index === 1 ? 'url(#silver-grad)' : 'url(#bronze-grad)'" 
                            :stroke="index === 0 ? '#F9A825' : index === 1 ? '#9E9E9E' : '#8D6E63'" 
                            stroke-width="1"
                            filter="url(#medal-shadow)"
                          />
                          <text x="16" y="21" text-anchor="middle" font-size="15" font-weight="800" 
                            :fill="index === 0 ? '#916200' : index === 1 ? '#424242' : '#3E2723'" 
                            font-family="Lato, sans-serif">{{ item.order_Ratio }}</text>
                        </svg>
                      </div>
                      <span v-else class="rank-badge">{{ item.order_Ratio }}</span>
                      <div v-if="item.profilepic" class="profile-wrapper">
                        <img v-lazy="item.profilepic" :key="item.profilepic" class="image-profile-36 image-skeleton" />
                      </div>
                      <div v-else class="image image-profile-36">
                        <span class="text-in-image text-in-image-36 flex-mid">{{ item.shortname }}</span>
                      </div>
                      <div class="member-info">
                        <span class="member-name fs-13 fw-700 fc-000000">{{ item.firstname + ' ' + item.lastname }}</span>
                        <span class="member-team pt-2 fs-11 fw-400 opa-08 fc-000000">{{ item.teamname }}</span>
                      </div>
                    </div>
                    <div class="rank-value">
                      <span class="fs-14 fw-700 fc-000000">{{ item.ratio }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <span @click.prevent="showlistData(recognitionRatio,'recognition',5,'rive_to_receive_ratio','order_Ratio')" class="see-full-list">
                  See full list
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Alignment Metrics Section -->
        <div class="leaderboard-section mt-40">
          <div class="section-header">
            <span class="section-title fs-15 fw-700">Alignment Metrics</span>
            <span class="section-subtitle fs-12 opa-06 ml-12">Values alignment performance</span>
          </div>
          <div class="leaderboard-grid">
            <!-- Strongest Alignment Given -->
            <div class="leaderboard-card alignment-accent">
              <div class="card-header">
                <div class="card-title fw-700">Strongest Alignment Given</div>
                <div class="card-subtitle fs-12 opa-06">Most effective at reinforcing your values</div>
              </div>
              <div class="rank-list">
                <div v-for="(item,index) in alignmentGiven" :key="'align-given-'+index">
                  <div v-if="index<3" class="rank-item" :class="[ blurMode ? 'blurelement': '' ]">
                    <div class="rank-item-left">
                      <div class="rank-medal-wrapper" v-if="index < 3">
                        <svg width="32" height="32" viewBox="0 0 32 32" class="medal-icon">
                          <circle cx="16" cy="16" r="14" 
                            :fill="index === 0 ? 'url(#gold-grad)' : index === 1 ? 'url(#silver-grad)' : 'url(#bronze-grad)'" 
                            :stroke="index === 0 ? '#F9A825' : index === 1 ? '#9E9E9E' : '#8D6E63'" 
                            stroke-width="1"
                            filter="url(#medal-shadow)"
                          />
                          <text x="16" y="21" text-anchor="middle" font-size="15" font-weight="800" 
                            :fill="index === 0 ? '#916200' : index === 1 ? '#424242' : '#3E2723'" 
                            font-family="Lato, sans-serif">{{ item.order_alignmentGiven }}</text>
                        </svg>
                      </div>
                      <span v-else class="rank-badge">{{ item.order_alignmentGiven }}</span>
                      <div v-if="item.profilepic" class="profile-wrapper">
                        <img v-lazy="item.profilepic" :key="item.profilepic" class="image-profile-36 image-skeleton" />
                      </div>
                      <div v-else class="image image-profile-36">
                        <span class="text-in-image text-in-image-36 flex-mid">{{ item.shortname }}</span>
                      </div>
                      <div class="member-info">
                        <span class="member-name fs-13 fw-700 fc-000000">{{ item.firstname + ' ' + item.lastname }}</span>
                        <span class="member-team pt-2 fs-11 fw-400 opa-08 fc-000000">{{ item.teamname }}</span>
                      </div>
                    </div>
                    <div class="rank-value">
                      <span class="fs-14 fw-700 fc-000000">{{ item.alignmentGiven }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <span @click.prevent="showlistData(alignmentGiven,'alignmentGiven',3,'alignment_given','order_alignmentGiven')" class="see-full-list">
                  See full list
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </div>
            </div>

            <!-- Strongest Alignment Received -->
            <div class="leaderboard-card alignment-accent">
              <div class="card-header">
                <div class="card-title fw-700">Strongest Alignment Received</div>
                <div class="card-subtitle fs-12 opa-06">Most aligned actions with your values</div>
              </div>
              <div class="rank-list">
                <div v-for="(item,index) in alignmentReceived" :key="'align-received-'+index">
                  <div v-if="index<3" class="rank-item" :class="[ blurMode ? 'blurelement': '' ]">
                    <div class="rank-item-left">
                      <div class="rank-medal-wrapper" v-if="index < 3">
                        <svg width="32" height="32" viewBox="0 0 32 32" class="medal-icon">
                          <circle cx="16" cy="16" r="14" 
                            :fill="index === 0 ? 'url(#gold-grad)' : index === 1 ? 'url(#silver-grad)' : 'url(#bronze-grad)'" 
                            :stroke="index === 0 ? '#F9A825' : index === 1 ? '#9E9E9E' : '#8D6E63'" 
                            stroke-width="1"
                            filter="url(#medal-shadow)"
                          />
                          <text x="16" y="21" text-anchor="middle" font-size="15" font-weight="800" 
                            :fill="index === 0 ? '#916200' : index === 1 ? '#424242' : '#3E2723'" 
                            font-family="Lato, sans-serif">{{ item.order_alignmentReceived }}</text>
                        </svg>
                      </div>
                      <span v-else class="rank-badge">{{ item.order_alignmentReceived }}</span>
                      <div v-if="item.profilepic" class="profile-wrapper">
                        <img v-lazy="item.profilepic" :key="item.profilepic" class="image-profile-36 image-skeleton" />
                      </div>
                      <div v-else class="image image-profile-36">
                        <span class="text-in-image text-in-image-36 flex-mid">{{ item.shortname }}</span>
                      </div>
                      <div class="member-info">
                        <span class="member-name fs-13 fw-700 fc-000000">{{ item.firstname + ' ' + item.lastname }}</span>
                        <span class="member-team pt-2 fs-11 fw-400 opa-08 fc-000000">{{ item.teamname }}</span>
                      </div>
                    </div>
                    <div class="rank-value">
                      <span class="fs-14 fw-700 fc-000000">{{ item.alignmentReceived }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <span @click.prevent="showlistData(alignmentReceived,'alignmentReceived',4,'alignment_recieved','order_alignmentReceived')" class="see-full-list">
                  See full list
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </div>
            </div>

            <!-- Strongest Alignment Overall -->
            <div class="leaderboard-card alignment-accent">
              <div class="card-header">
                <div class="card-title fw-700">Strongest Alignment Overall</div>
                <div class="card-subtitle fs-12 opa-06">Top culture & values ambassadors</div>
              </div>
              <div class="rank-list">
                <div v-for="(item,index) in alignmentRatio" :key="'align-overall-'+index">
                  <div v-if="index<3" class="rank-item" :class="[ blurMode ? 'blurelement': '' ]">
                    <div class="rank-item-left">
                      <div class="rank-medal-wrapper" v-if="index < 3">
                        <svg width="32" height="32" viewBox="0 0 32 32" class="medal-icon">
                          <circle cx="16" cy="16" r="14" 
                            :fill="index === 0 ? 'url(#gold-grad)' : index === 1 ? 'url(#silver-grad)' : 'url(#bronze-grad)'" 
                            :stroke="index === 0 ? '#F9A825' : index === 1 ? '#9E9E9E' : '#8D6E63'" 
                            stroke-width="1"
                            filter="url(#medal-shadow)"
                          />
                          <text x="16" y="21" text-anchor="middle" font-size="15" font-weight="800" 
                            :fill="index === 0 ? '#916200' : index === 1 ? '#424242' : '#3E2723'" 
                            font-family="Lato, sans-serif">{{ item.order_alignmentRatio }}</text>
                        </svg>
                      </div>
                      <span v-else class="rank-badge">{{ item.order_alignmentRatio }}</span>
                      <div v-if="item.profilepic" class="profile-wrapper">
                        <img v-lazy="item.profilepic" :key="item.profilepic" class="image-profile-36 image-skeleton" />
                      </div>
                      <div v-else class="image image-profile-36">
                        <span class="text-in-image text-in-image-36 flex-mid">{{ item.shortname }}</span>
                      </div>
                      <div class="member-info">
                        <span class="member-name fs-13 fw-700 fc-000000">{{ item.firstname + ' ' + item.lastname }}</span>
                        <span class="member-team fs-12 fw-400 opa-08 fc-000000">{{ item.teamname }}</span>
                      </div>
                    </div>
                    <div class="rank-value">
                      <span class="fs-14 fw-700 fc-000000">{{ item.alignmentRatio }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <span @click.prevent="showlistData(alignmentRatio,'alignmentRatio',5,'avg_alignment_combined','order_alignmentRatio')" class="see-full-list">
                  See full list
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <el-dialog :visible.sync="openModal" :before-close="closeModal" width="1100px"  top="8vh">
        <div class="flex-center" style="background-color:#F8F8F8;">
          <div class="modal-1" style="width:764px; ">
            <div class="flex-column" style="margin-top: 40px;">
              <span class="fs-20 fw-700" style="color: #000; ">
                Full List of 
                {{ excelname === 'recognition_given' ? 'Recognition Given' : 
                   excelname === 'recognition_recieved' ? 'Recognition Received' : 
                   excelname === 'rive_to_receive_ratio' ? 'Give-to-Receive Ratio' : 
                   excelname === 'alignment_given' ? 'Strongest Alignment Given' : 
                   excelname === 'alignment_recieved' ? 'Strongest Alignment Received' : 
                   excelname === 'avg_alignment_combined' ? 'Strongest Alignment Combined' : '' }}
              </span>
              <div class="flex-row-between" style="margin-top: 20px;">
                <div class="flex-mid">
                  <div  style="height: 32px;margin-top: 13px;">
                    <span class="reconigtion-tags-selected  fs-13" >{{this.selectRecognition=='All'?'All Recognition':this.selectRecognition}}</span>
                  </div>
                </div>
                <div  class="flex-mid">
                  <el-input
                    class="input-style med-width"
                    style="height: 40px ;margin-right: 24px;"
                    autosize
                    :placeholder="$t('members.Search')"
                    @keyup.native="searchData"
                    v-model="inputSearch"
                    clearable
                  ></el-input>
                  <svg
                    @click="downloadData()"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-export"
          >
            <path
              fill="currentColor"
              d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
                    />
                  </svg>
                </div>
              </div>
              
              <div  style="margin-top: 21px;">
                <el-table
                    :cell-style="cellStyle"
                    :header-cell-style="cellStyleheader"
                    id="memberleaderboardTable"
                    ref="memberleaderboardTable"
                    :data="membersperpage"
                    style="width: 100%"
                    class="fc-000000"
                   
                    :empty-text="
                    loadingMemberTable
                      ? ' '
                    : !loadingMemberTable && inputSearch === ''
                    ? 'No members'
                    : 'No results found...'
                  "
                >
                
                  
                <el-table-column
                      prop="name"
                      label="Rank"
                      width="52"
                    >
                      <template slot-scope="scope">
                        <div class="flex-column">
                          <span class="fs-14 fw-700 opa-03 center"
                            >{{ scope.row.rank }}</span
                          >
                        </div>
                      </template>
                </el-table-column>
                <el-table-column width="42">
                  <template slot-scope="scope">
                    <div class="absolute-mid">
                      <img
                        v-if="scope.row.profilepic"
                        v-lazy="scope.row.profilepic"
                        :key="scope.row.profilepic"
                        class="image-skeleton image-profile-42 flex-mid "
                        :class="[ blurMode ?  'blurelement': '' ]"
                      />
                      <div v-else class="image image-profile-42 flex-mid"
                      :class="[ blurMode ?  'blurelement': '' ]">
                        <div class="text-in-image text-in-image-42 flex-mid">
                          {{
                            $utils("acronymName", {
                              firstName: scope.row.firstname,
                              lastName: scope.row.lastname,
                            })
                          }}
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                
                <el-table-column
                  prop="name"
                  width="180"
                >
                  <template slot="header">
                    <span class="fs-14 fw-700">Name</span><br> <span class="fs-13 fw-400">Team</span>
                  </template>

                  <template slot-scope="scope">
                    <div class="flex-column">
                      <span class="fs-14 fw-700 ellipsis"
                      :class="[ blurMode ?  'blurelement': '' ]"
                        >{{ scope.row.firstname }} {{ scope.row.lastname }}</span
                      >
                      <span class="fs-12 opa-08 ellipsis"
                      :class="[ blurMode ?  'blurelement': '' ]" style="margin-top:-5px;">{{ scope.row.teamname }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="name"
                  width="120"
                  header-align="center"
                  align="center"
                >
                  <template slot="header">
                    <span class="fs-14 fw-700">Given</span><br> <span class="fs-13 fw-400">Avg Alignment</span>
                  </template>

                  <template slot-scope="scope">
                    <div class="flex-column">
                      <span class="fs-13 fw-700 interactive"
                      @click="rowClickEdit(scope.row,'given')"
                        >{{ scope.row.given}} </span
                      >
                      <span class="fs-12" style="margin-top:-5px;">{{ scope.row.alignmentGiven?scope.row.alignmentGiven:0 }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="name"
                  width="120"
                  header-align="center"
                  align="center"
                >
                  <template slot="header">
                    <span class="fs-14 fw-700">Received</span><br> <span class="fs-13 fw-400">Avg Alignment</span>
                  </template>
                  
                  <template slot-scope="scope">
                    <div class="flex-column">
                      <span class="fs-13 fw-700 interactive"
                      @click="rowClickEdit(scope.row,'received')"
                        >{{ scope.row.received }}</span
                      >
                      <span class="fs-12" style="margin-top:-5px;">{{ scope.row.alignmentReceived?scope.row.alignmentReceived:0 }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="name"
                  width="120"
                  header-align="center"
                  align="center"
                >
                  <template slot="header">
                    <span class="fs-14 fw-700">Giver Ratio</span><br> <span class="fs-13 fw-400">Align. Combined</span>
                  </template>

                  <template slot-scope="scope">
                    <div class="flex-column">
                      <span class="fs-13"
                        >{{ scope.row.ratio }} </span
                      >
                      <span class="fs-12" style="margin-top:-5px;">{{ scope.row.alignmentRatio?scope.row.alignmentRatio:0 }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="Impact Rating"
                  width="90"
                  header-align="center"
                  align="center"
                >
                  <template slot="header">
                    <span class="fs-14 fw-700">Impact<br>Rating</span>
                  </template>
                  <template slot-scope="scope">
                    <div class="flex-column flex-mid" style="widows: 100%;">
                      <span 
                        :class="{
                          'impact-label': true,
                          'flex-column': true,
                          'green':scope.row.impactRating>= 70,
                          'yellow': scope.row.impactRating>= 50 && scope.row.impactRating< 70,
                          'red': scope.row.impactRating < 50
                        }"
                      >{{ scope.row.impactRating ? Math.round(scope.row.impactRating) : 0 }} </span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="flex-center pagination mt-10">
                <el-pagination @current-change="handleCurrentChangePage" :current-page="1" :page-size="10" :pager-count="5"
                  layout="prev, pager, next" :total="totalpage"></el-pagination>
                <span class="results-status">
                  {{ totalpage > 10 ? 10 : totalpage }}
                  {{ $t("insights.results_from") }}
                  {{ $utils("addCommasInNumber",  totalpage) }}
                  {{ $t("insights.results") }}
                </span>
              </div>
              </div>

            </div>
          </div>

          <div class="modal-2" style="width:360px;">
            <div v-if="!statusOnclick" class="flex-center" style="padding-left: 60px;padding-right: 60px;height:100%;">
       
                <span class="fs-14" style="text-align: center; opacity: 0.6; width: 216px; word-break: normal;">Select a Given or Received amount to view a transaction log</span>

            </div>
            <div v-else>
                <div class="flex-column fc-000000 " style="margin: 84px 24px 0px 24px; padding-bottom: 30px;" >
                  <span class="fs-14 fw-700"
                  :class="[ blurMode ?  'blurelement': '' ]">{{ title }}</span>
                  <div v-for="item in recognitionGivenbyrow" :key="item.id" style="margin-top: 24px;">
                    <div class="flex-column">
                        <span class="fs-11 fw-700">{{ item.dateFormatted }}</span>
                    
                        <div class="flex-row-center recognition-card"
                        :class="[ blurMode ?  'blurelement': '' ]">
                          <div class="flex-mid mr-12" style="width: 32px;">
                            <img
                              v-if="item.profilepic"
                              v-lazy="item.profilepic"
                              :key="item.profilepic"
                              class="image-skeleton image-profile-32 flex-mid"
                            />
                            <div v-else class="image image-profile-32 flex-mid">
                              <div class="text-in-image text-in-image-32 flex-mid">
                                {{
                                item.shortname
                                }}
                              </div>
                            </div>
                          </div>

                          <div class="fs-13" style="width: 204px;">
                            <span class="fw-700">{{ item.send_to_name_show }} </span> got <span class="fw-700">+{{ item.point }} {{ item.type }}</span> from <span class="fw-700">{{ item.send_anony_name_show }}</span> for {{ item.reason }}
                            <span v-for="(items,index) in item.hashtags" :key="index" class="fw-700" style="color: #32C2D5;">{{ items.name }} </span>
                          </div>
                        </div>
                        <div v-for="(items,index) in item.hashtags" :key="index" class="value-alignment-item">
                          <div class="flex-between mb-4">
                            <span class="fs-11 fw-700 fc-000000 opa-08">{{ items.name }}</span>
                            <span class="fs-11 fw-700 fc-000000 opa-08">{{ items.rating ? items.rating.toFixed(1) : '0' }}</span>
                          </div>
                          <div class="progress-track">
                            <div class="progress-fill" :style="{ width: (items.rating ? items.rating * 10 : 0) + '%', backgroundColor: getScoreColor(items.rating) }"></div>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>

        </div>
      
      </el-dialog>

    <el-dialog  id="openModaldate"  :visible.sync="openModaldate" :before-close="closeModaldate" width="530px">
      <div class="mx-12">
        <div class="ml-24 mb-24 fc-4A4A4A fs-16 fw-700" style="padding-top: 40px;">
          {{ $t("powerUp.Date_Range") }}
        </div>
        <div class="center">
          <el-date-picker
            v-model="customdate"
            type="daterange"
            unlink-panels
            range-separator="To"
            align="center"
            start-placeholder="Start date"
            end-placeholder="End date"
            :default-time="['12:00:00', '08:00:00']"
            
            size='large'
          />
        </div>
        <div class="flex mt-40 mr-32">
          <div class="btn-gray flex-mid btn-export cursor-pointer ml-auto" @click.prevent="closeModaldate">
            <div class="">{{ $t("powerUp.Cancel") }}</div>
          </div>
          <div class="btn-add flex-mid btn-export cursor-pointer ml-16" @click="handleOk">
            <div class="">{{ "Confirm & Filter" }}</div>
          </div>
        </div>
      </div>
    </el-dialog>


    </div>
  </div>
</template>
    
<script>
import format from 'date-fns/format'
import addDays from "date-fns/add_days";
export default {
  name: "leaderboards",
  components: {
    loadingEven: require("../even/loading").default,
  },
  data() {
    return {
      inputSearch: "",
      loadingMemberTable:false,
      list_month_select: "Past 6 months",
      pre_list_month_select: "Past 6 months",
      selectTeam: "",
      selectRecognition: "All",
      openModaldate:false,
      openModal:false,
      statusOnclick:false,
      recognitionGivenbyrow:[],
      membersperpage:[],
      members:[],
      membersAll:[],
      title:'',
      type:'',
      highlight:0,
      totalpage:0,
      masterData:[],
      type:'',
      excelname:'',
      customdate: [
        new Date(),
        new Date(),
      ],
      scheduleStaus: false,

      // pickerOptions: {
      //     shortcuts: [{
      //       text: 'Last week',
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      //         picker.$emit('pick', [start, end]);
      //       }
      //     }, {
      //       text: 'Last month',
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      //         picker.$emit('pick', [start, end]);
      //       }
      //     }, {
      //       text: 'Last 3 months',
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      //         picker.$emit('pick', [start, end]);
      //       }
      //     }]
      // },


    };
  },
  async created() {
    // this.$nextTick(() => this.startTimer());
    this.$store.dispatch("leaderboards/getTeam1level", this.user);
    this.$store.dispatch("leaderboards/getList_month");
    this.$store.dispatch("leaderboards/getteamAndcohort", this.user);
    this.$store.dispatch("leaderboards/getRecognition", this.user);
    //await this.$store.dispatch("leaderboards/calculateImpactRating", this.user); 
    this.$store.dispatch("leaderboards/getHerepoint", this.user);
    
    
    
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    list_month() {
      return this.$store.getters["leaderboards/list_month"];
    },
    teamAndcohort() {
      return this.$store.getters["leaderboards/teamAndcohort"];
    },
    recognition(){
        return this.$store.getters["leaderboards/recognitionValue"];
    },
    recognitionGiven(){
      return this.$store.getters["leaderboards/recognitionGiven"];
    },
    recognitionReceived(){
      return this.$store.getters["leaderboards/recognitionReceived"];
    },
    recognitionRatio(){
      return this.$store.getters["leaderboards/recognitionRatio"];
    },
    alignmentGiven(){
      return this.$store.getters["leaderboards/alignmentGiven"];
    },
    alignmentReceived(){
      return this.$store.getters["leaderboards/alignmentReceived"];
    },
    alignmentRatio(){
      return this.$store.getters["leaderboards/alignmentRatio"];
    },
    givenMember(){
      return this.$store.getters["leaderboards/givenMember"];
    },
    receivedMember(){
      return this.$store.getters["leaderboards/receivedMember"];
    },
    impactRating(){
      return this.$store.getters["leaderboards/impactRating"];
    },
    loadingsImpactRating(){     
      return this.$store.getters["leaderboards/loadingsImpactRating"];
    },
    loadings(){     
      return this.$store.getters["leaderboards/loadings"];
    },
    pickerOptions(){
      return this.$store.getters["leaderboards/pickerOptions"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
  },

  mounted() {
   // console.log("leaderboards");
  },
  watch:{
    inputSearch() {
    
    },
    teamAndcohort: {
    handler(newVal) {
      if (this.selectTeam === "" && Object.keys(newVal).length > 0) {
        this.selectTeam = this.user.user_type === "leadership" 
          ? this.user.team 
          : "All Teams and Cohorts";
        
      }
    },
    immediate: true  
    },
   
  },
  
  methods: {
    disabledDate(date) {
      const date6 = format(addDays(new Date(), -180), 'YYYY-MM-DD')
       if (new Date(date6) > new Date(date)) {
         return true
       }
       return false;
     },
    cellStyle({row, column,columnIndex,rowIndex}){
      if(rowIndex==9&&columnIndex == this.highlight){
        return 'background-color: rgb(108, 48, 204,0.04);border-bottom-left-radius: 15px;border-bottom-right-radius: 15px;'
      }else if(columnIndex ==this.highlight){
        return 'background-color: rgb(108, 48, 204,0.04);'
      }
    },
    cellStyleheader({row, column,columnIndex,rowIndex}){
      
      if(columnIndex == this.highlight){
        return 'font-size:14px;background-color: rgb(108, 48, 204,0.04); border-top-left-radius: 15px;border-top-right-radius: 15px;'
      }else{
        return 'font-size:14px;'
      }
    },
    handleCurrentChangePage(val) {
    
    let start_row = (val - 1) * 10
    let end_row = ((val - 1) * 10) + 10
    this.membersperpage=this.members.slice(start_row,end_row);

    },
    getScoreColor(rating) {
      if (!rating) return '#F44336';
      if (rating >= 8) return '#66BB6A';
      if (rating >= 5) return '#FAD71A';
      return '#F44336';
    },
    setColor(rating){
      // console.log("rating",rating)
      let width = (rating / 10) * 160;
      if (rating >= 8) {
        return `border-bottom: 2px solid #66BB6A; margin-top:12px;width:${width}px`
      } else if (rating >= 5 && rating < 8) {
        return `border-bottom: 2px solid #FAD71A; margin-top:12px;width:${width}px`
      } else {
        return `border-bottom: 2px solid #F44336; margin-top:12px;width:${width}px`
      }
    },
    rowClickEdit(row,type) {
      if(type=='given'){
        this.title='Recognition Given by '+this.givenMember[row.email][0].send_anony_name_show
      this.recognitionGivenbyrow=_.orderBy(this.givenMember[row.email], function(dateObj) {
              return new Date(dateObj.date);
            },['desc']);
      }else{
        this.title='Recognition Received by '+this.receivedMember[row.email][0].send_to_name_show
        this.recognitionGivenbyrow=_.orderBy(this.receivedMember[row.email], function(dateObj) {
              return new Date(dateObj.date);
            },['desc']);
      }

     
       
      this.statusOnclick=true;
    },
    setClassRecognition(value){
        if(this.selectRecognition == value){
            return true;
        }else{
            return false;
        }
    },
    setRecognition(value){
        this.selectRecognition=value
        this.$store.dispatch("leaderboards/filtersReconition", value);
    },
    async showlistData(data,type,highlight,excelname,rank){
        this.excelname=excelname
        this.highlight=highlight
        this.openModal=true;
        this.masterData=data;
        this.type=type;
        this.members=data;
        this.membersAll=data;
        this.totalpage=data.length;
        // let rank=0
        this.statusOnclick=false;
        if(type=='recognition'){
          for(const i in this.members){
          this.type="recognition"
          // rank++
          const findalignment= _.find(this.alignmentGiven, function (_value) {
                  return _value.email == data[i].email;
          });
        
          this.members[i].rank=this.members[i][rank];
          if(findalignment){
            this.members[i].alignmentGiven=findalignment.alignmentGiven;
            this.members[i].alignmentReceived=findalignment.alignmentReceived;
            this.members[i].alignmentRatio=findalignment.alignmentRatio;
          }
          // const emailKey=this.members[i].email.replace(/\./g, '||')
    
          // this.members[i].impactRating=this.impactRating[emailKey]? this.impactRating[emailKey].impact_rating:0;

        }

        }else{
          for(const i in this.members){
          // rank++
          const findRecognition= _.find(this.recognitionGiven, function (_value) {
                  return _value.email == data[i].email;
          });
          this.members[i].rank=this.members[i][rank];
          if(findRecognition){
            this.members[i].given=findRecognition.given
            this.members[i].received=findRecognition.received
            this.members[i].ratio=findRecognition.ratio
          }
          // const emailKey=this.members[i].email.replace(/\./g, '||')
          // this.members[i].impactRating=this.impactRating[emailKey]? this.impactRating[emailKey].impact_rating:0;
          }

        }
        this.membersperpage=this.members.slice(0,10);
        this.members=this.members
        this.membersAll=this.members
        // console.log(this.membersperpage);
    },
    closeModal(){
        this.openModal=false;
        this.statusOnclick=false;
        this.inputSearch= ""
       
        if(this.scheduleStaus){
          this.$store.dispatch("leaderboards/changeTimeScedule", this.customdate);
        }else{
          this.$store.dispatch("leaderboards/changeTime",'');
        }
        
                 
    },
    closeModaldate(){
        this.openModaldate=false;
        this.list_month_select = this.pre_list_month_select
    },
    
    async changMainPageData(key) {
      // console.log(key);
      this.$store.dispatch("leaderboards/changeTeam", key);

    },
    changeTime(id) {
      // console.log(id);
     
      this.list_month_select = id.name;
      if(id.name=='Custom Date Range'){
        this.scheduleStaus=true;
        this.openModaldate=true;
      }else{
        this.scheduleStaus=false
        this.pre_list_month_select=id.name
          this.$store.dispatch("leaderboards/changeTime", id.name);
        }
      
    },
    searchData(){
      // console.log(this.inputSearch);
      this.membersperpage=this.membersAll.filter((item)=>{
        return item.firstname.toLowerCase().includes(this.inputSearch.toLowerCase()) || item.lastname.toLowerCase().includes(this.inputSearch.toLowerCase()) || item.teamname.toLowerCase().includes(this.inputSearch.toLowerCase())
      })
      this.members=this.membersperpage;
      this.totalpage=this.membersperpage.length;
      this.membersperpage=this.membersperpage.slice(0,10);
    },
    downloadData(){
     
      const  excelname=this.excelname
      const Excel = require("exceljs");
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet("mySheet");
      /*TITLE*/
      ws.getCell("B2").font = { name: "Arial", size: 18, bold: true };
      ws.getCell("B2").alignment = { vertical: "middle" };
      ws.getCell("B2").value = "Recognition Leaderboard";
      let header = [
        "Rank",
        "Name",
        "Team Name",
        "Given",
        "Avg Alignment",
        "Received",
        "Avg Alignment",
        "Giver Ratio",
        "Align. Combined",
        "Impact Rating"
      ];
      ws.getRow(2).values = header;
        _.forEach(this.members, (item, key) => {
          let _tmp = [
            item.rank,
            item.firstname+' '+item.lastname,
            item.teamname,
            item.given,
            item.alignmentGiven,
            item.received,
            item.alignmentReceived,
            item.ratio,
            item.alignmentRatio,
            item.impactRating,
          ];
          ws.addRow(_tmp);
      })
      wb.xlsx
        .writeBuffer({
          base64: true,
        })
        .then(function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          var url = URL.createObjectURL(data);
          a.href = url;
          a.download =excelname +".xlsx";
          document.body.appendChild(a);
          a.click();
        })
        .catch(function (error) {
          console.log(error.message);
        });
    },
    handleOk(){
        this.openModaldate=false;
        this.list_month_select= format(new Date(this.customdate[0]), 'MMM D')+ ' To ' +format(new Date(this.customdate[1]), 'MMM D')
        this.pre_list_month_select=this.list_month_select
        this.$store.dispatch("leaderboards/changeTimeScedule", this.customdate);
     

    }
  },
};
</script>
  
<style lang="scss" scoped>
.menuOptionPowerup {
  width: 200px;
  border-radius: 4px;
  height: 40px;
}
.menu-list-item {
  color: #4a4a4a;
}
.el-menu--horizontal .el-menu .el-menu-item:hover .menu-list-item {
  color: white;
  font-weight: 600;
}
.txtOptionShowing {
  color: #000000;
  font-size: 14px;
  margin-left: 16px;
}
.reconigtion-tags {
  font-size: 13px;
  font-weight: 700;
  border: 1px solid #707070;
  background-color: #FFFFFF;
  color: #000000;
  padding: 8px 24px 8px 24px;
  transition: 0.2s;
  border-radius: 21px;
  opacity: 0.8;
  cursor: pointer;
  &:hover {
    border:1px solid #00ACC1;
    color: #00ACC1;
    opacity: 1;
  }
}
.reconigtion-tags-selected {
  font-size: 13px;
  font-weight: 700;
  border:1px solid #00ACC1;
  background-color: #32C2D5;
  border-radius: 21px;
  color: #FFFFFF;
  padding: 8px 24px 8px 24px;
  transition: 0.2s;
  border-radius: 21px;
  cursor: default;
}
.el-button--default.is-round:hover,
.el-button--default.is-round:focus {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 0.7;
}

.el-button--default.is-round:active {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 1;
}

// Animation Keyframes
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shimmer {
  0% { transform: translateX(-100%) skewX(-15deg); }
  100% { transform: translateX(200%) skewX(-15deg); }
}

// Leaderboard Section Styles
// ==========================================

.leaderboard-section {
  margin-bottom: 24px;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}

.section-title {
  color: #2e2e2e;
}

.section-subtitle {
  color: #747474;
}

.leaderboard-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
}

.leaderboard-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 14px 16px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  min-width: 0; // Prevents grid blowout
  animation: slideIn 0.5s ease-out forwards;
  opacity: 0; // Start invisible for animation

  &:nth-child(1) { animation-delay: 0.1s; }
  &:nth-child(2) { animation-delay: 0.2s; }
  &:nth-child(3) { animation-delay: 0.3s; }

  &:hover {
    border-color: #d0d0d0;
    transform: translateY(-4px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.05);
  }

  &.recognition-accent {
    border-left: 3px solid #32c2d5;
  }

  &.alignment-accent {
    border-left: 3px solid #6c30cc;
  }
}

.card-header {
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.card-title {
  color: #2e2e2e;
  margin-bottom: 2px;
  font-size: 14px;
}

.card-subtitle {
  color: #747474;
}

.rank-list {
  min-height: 160px;
}

.rank-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 6px;
  margin: 2px -6px;
  border-radius: 4px;
  transition: background-color 0.15s ease;
  min-width: 0;

  &:hover {
    background-color: #f8f8f8;
  }
}

.rank-item-left {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.rank-medal-wrapper {
  margin-right: 10px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rank-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  margin-right: 10px;
  color: #4a4a4a;
  background-color: #f4f4f4;
  flex-shrink: 0;
}

.profile-wrapper {
  width: 36px;
  flex-shrink: 0;
}

.member-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
  overflow: hidden;
  margin-left: 10px;
}

.member-name {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.member-team {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: -2px;
}

.rank-value {
  flex-shrink: 0;
  padding-left: 12px;
}

.card-footer {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
}

.see-full-list {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #32c2d5;
  cursor: pointer;
  transition: color 0.15s ease, gap 0.15s ease;

  &:hover {
    color: #2aa3b3;
    gap: 8px;
  }

  svg {
    transition: transform 0.15s ease;
  }

  &:hover svg {
    transform: translateX(2px);
  }
}

// ==========================================
// Modal Styles
// ==========================================

.modal-1{
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 0px 40px 40px 0px;
    opacity: 1;
    height: 84vh;
    min-height: 847px;
    padding-left: 40px;
    padding-right: 40px;
    max-height: 1200px;

}
.modal-2{
  overflow-y: scroll;
  background: #F8F8F8 0% 0% no-repeat padding-box;
  opacity: 1;
  height: 84vh;
  min-height: 847px;
  max-height: 1200px;
}
#tabLeaderboards .modal-2 {
  padding-right: 10px;
  padding-left: 10px;
  // padding-bottom: 20px;
}
.txtName, .txtTeam {
  width: 150px;
}
.btn-export {
  font-size: 13px;
  font-weight: 700;
  padding: 12px 16px;
  border-radius: 3px;
}

// Modal Alignment styles
.value-alignment-item {
  margin-top: 12px;
}

.progress-track {
  width: 100%;
  height: 4px;
  background-color: #f0f0f0;
  border-radius: 2px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  border-radius: 2px;
  transition: width 0.3s ease;
}
</style>
<style lang="scss">
#memberleaderboardTable > div.el-table__header-wrapper  > table > thead
  > tr > th>.labelTable.is-leaf>.cell{
   text-align: center;
}
#tabLeaderboards .el-dialog > .el-dialog__header {
  padding: 0px;
}
#tabLeaderboards .el-dialog>.el-dialog__body {
  padding: 0px;
  height: 84vh;
  min-height: 847px;
  max-height: 1200px;
}
#tabLeaderboards  .el-dialog {
  width: 1100px;
  
}
#tabLeaderboards .el-submenu__title {
  height: 40px;
  line-height: 40px;
  background-color: #f4f4f4;
  width: 200px;
  margin-right: 46px;
}
#tabLeaderboards .el-menu--horizontal > .el-menu-item {
  // color: rgba(0, 0, 0, 0.62);
  font-size: 14px;
  font-weight: 400;
  height: 40px;
}
#tabLeaderboards .el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus .el-menu-item:hover {
  background-color: transparent;
  color: #6c30cc;
}
#tabLeaderboards .el-menu--horizontal > .el-menu-item.is-active {
  background-color: transparent;
  border-bottom: 2px solid #6c30cc;
  color: #6c30cc;
  font-weight: 700;
}
#tabLeaderboards .el-table .el-table__cell {
  padding: 6px 0;
}
#tabLeaderboards .el-table th.el-table__cell > .cell {
  line-height: 18px;
}
#tabLeaderboards .recognition-card {
  // width: 288px;
  background-color: #FFFFFF; 
  margin-top:7px;
  border-radius: 6px;
  padding: 12px 24px 12px 16px;
  word-break: normal;
}
#tabLeaderboards .interactive {
  text-decoration-line: underline;
  cursor: pointer;
}
#tabLeaderboards .input-style.med-width {
  width: 240px !important;
}
// #tabLeaderboards .icon-export {
//   opacity: 1;
// }
#tabLeaderboards .impact-label {
  border-radius: 4px;
  width: 44px;
  font-size: 13px;
  font-weight: 700;
}
.impact-label.green {
  background-color:#66BB6A30;
  color:#28642A;
}
.impact-label.yellow {
  background-color:#FBC02D30;
  color:#745301;
}
.impact-label.red {
  background-color:#F4433630;
  color:#6E1D17;
}
#menuSortMonth > li > div {
  border-radius: 4px;
  width: 240px;
  height: 36px;
  line-height: 40px;
}
#menuSortMonth > li {
  margin-top: 0px;
  width: 240px;
  height: 36px;
}
#menuSortMonth > li > div > i {
  margin-right: 9%;
  float: right;
  margin-top: 6%;
}
#tabLeaderboards #openModaldate .el-dialog > .el-dialog__body {
    min-height: 0px;
    height: auto;
    padding: 0 0px 32px 0px;
}
</style>
